import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { HlmAlertDialogImports } from '@spartan-ng/helm/alert-dialog';
import { AuthService } from './core/services/auth.service';
import { SessionExpiredService } from './core/services/session-expired.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HlmAlertDialogImports],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  // Estado del diálogo global de sesión expirada, alimentado por el interceptor HTTP.
  protected readonly sessionExpired = inject(SessionExpiredService);

  /**
   * Acción del botón del diálogo: oculta el diálogo, limpia el estado local y redirige al login.
   */
  onSessionExpiredConfirm(): void {
    this.sessionExpired.dismiss();
    this.authService.clearSession();
    this.router.navigate(['/login']);
  }
}
